(function() {
  $(document).ready(function() {
    'use strict';
    $('.wizard').steps({
      headerTag: "h3",
      bodyTag: "div",
      transitionEffect: "slideLeft",
      autoFocus: true,
      enableAllSteps: false,
      enableFinishButton: true,
      enablePagination: true
    });
  });

}).call(this);
